import React from 'react'
import { Typography } from '@mui/material'
import { ChevronRightMinor, ClockMajor } from '@shopify/polaris-icons'
import { DefaultStyleType } from 'src/interfaces/styles'
import tw from 'twin.macro'

export interface InfoContainerProps {
  className?: DefaultStyleType
  title: string
  children: React.ReactNode
  onClick?(): void
}

export const InfoMultilineContainer = ({
  title,
  children,
  className,
  onClick,
}: InfoContainerProps) => {
  return (
    <div
      css={[
        onClick
          ? tw`bg-primary-100 hover:bg-primary-200 p-4 rounded-lg flex flex-col cursor-pointer`
          : tw`bg-primary-100 p-4 rounded-lg flex flex-col`,
        className,
      ]}
      onClick={onClick}
    >
      <div css={tw`flex flex-row content-center mb-1`}>
        <ClockMajor css={tw`w-5 h-5 mr-2 fill-primary-500`} />
        <Typography variant="h4" css={tw`text-primary-500`}>
          {title}
        </Typography>
      </div>
      <div>
        <div css={tw`flex flex-col`}>
          <Typography css={tw`text-primary-500`}>{children}</Typography>
        </div>
      </div>
      {onClick ? (
        <div css={tw`ml-[16px] h-[20px]`}>
          <ChevronRightMinor width={20} css={tw`fill-primary-500`} />
        </div>
      ) : null}
    </div>
  )
}
